module.exports = __webpack_public_path__ + "img/cerrar.c1a0a65d.svg";